// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"39542":"bc317e0933440b76","42922":"ac28b4a7032ac117","72499":"7ebe4acd85434163","80995":"3af545b8fb550898"}[chunkId] + ".css";
};